import { createSelector } from 'reselect';

export const getComponentState = state => state.orders;

export const getType = createSelector(
    getComponentState,
    (state) => state.type
);
export const getOrders = createSelector(
    getComponentState,
    (state) => state.orders
);
export const getFetching = createSelector(
    getComponentState,
    (state) => state.fetching
);
export const getIdModal = createSelector(
    getComponentState,
    (state) => state.idModal
);
export const getIsApproving = createSelector(
    getComponentState,
    (state) => state.isApproving
);
export const getIsRejecting = createSelector(
    getComponentState,
    (state) => state.isRejecting
);
export const getIsFromEmail = createSelector(
    getComponentState,
    (state) => state.isFromEmail
);
export const getPagination = createSelector(
    getComponentState,
    (state) => state.pagination
);
export const getExportingACMExcel = createSelector(
    getComponentState,
    (state) => state.exportingACMExcel
);
export const getExportingUTPExcel = createSelector(
    getComponentState,
    (state) => state.exportingUTPExcel
);
export const getExportingOrder = createSelector(
    getComponentState,
    (state) => state.exportingOrder
);
export const getSort = createSelector(
    getComponentState,
    (state) => state.sort
);
export const getSearch = createSelector(
    getComponentState,
    (state) => state.search
);
export const getSearchType = createSelector(
    getComponentState,
    (state) => state.searchType
);
export const getIsCheckingSCTicket = createSelector(
    getComponentState,
    (state) => state.isCheckingSCTicket
);
export const getIsCreatingSCTicket = createSelector(
    getComponentState,
    (state) => state.isCreatingSCTicket
);
export const getTicketExists = createSelector(
    getComponentState,
    (state) => state.ticketExists
);
export const getScTicketId = createSelector(
    getComponentState,
    (state) => state.scTicketId
);
export const getTrackingNumber = createSelector(
    getComponentState,
    (state) => state.trackingNumber
);
export const getShipped = createSelector(
    getComponentState,
    (state) => state.shipped
);
export const getIsSavingShipping = createSelector(
    getComponentState,
    (state) => state.isSavingShipping
);
export const getShippingMethod = createSelector(
    getComponentState,
    (state) => state.shippingMethod
);
export const getShippingQuantity = createSelector(
    getComponentState,
    (state) => state.shippingQuantity
);
export const getShippingWeight = createSelector(
    getComponentState,
    (state) => state.shippingWeight
);
export const getShippingNumPackages = createSelector(
    getComponentState,
    (state) => state.shippingNumPackages
);
export const getPackingSlipMessage = createSelector(
    getComponentState,
    (state) => state.packingSlipMessage
);
export const getPackingSlipItems = createSelector(
    getComponentState,
    (state) => state.packingSlipItems
);
export const getSavingPackingSlip = createSelector(
    getComponentState,
    (state) => state.savingPackingSlip
);
export const getPrintingPackingSlip = createSelector(
    getComponentState,
    (state) => state.printingPackingSlip
);
export const getFetchingPackingSlipData = createSelector(
    getComponentState,
    (state) => state.fetchingPackingSlipData
);
export const getOrderProducts = createSelector(
    getComponentState,
    (state) => state.orderProducts
);
export const getScTicketSelectedItems = createSelector(
    getComponentState,
    (state) => state.scTicketSelectedItems
);
export const getGeneratingPrintReadyFile = createSelector(
    getComponentState,
    (state) => state.generatingPrintReadyFile
);